<template>
  <DialogComponent
    ref="dialog"
    type="fullscreen"
    :dialogVisible="isOpen"
    @closed="onClosed"
    noInnerPadding
    mainClass="[&_.fullscreenDialogBox]:overflow-hidden!"
    hideCloseButton
  >
    <div class="h-full max-h-full flex flex-col bg-white overflow-hidden">
      <!-- Header -->
      <div class="p-4 bg-black flex-shrink-0">
        <div class="mobile-status-padding"></div>
        <div class="grid grid-cols-12 items-center justify-center">
          <div class="col-span-3 flex items-center">
            <div class="w-6 h-6 cursor-pointer" @click="close">
              <svg class="w-full h-full text-white -rotate-90" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7"/>
              </svg>
            </div>
          </div>
          <div class="col-span-6 text-white text-2xl font-bold text-center">
            Détails du brouillon
          </div>
          <div class="col-span-3 flex justify-end gap-2"></div>
        </div>
      </div>

      <!-- Content -->
      <div class="flex-1 min-h-0 overflow-hidden relative">
        <div class="absolute -top-6 inset-0 bg-white rounded-t-3xl flex flex-col pt-4">
          <div class="flex-1 overflow-auto pb-6">
            <SummaryStep v-if="draftData && draftData.results" :filledData="draftData.results" />
            <div v-else class="p-8 text-center text-gray-500">
              Aucune donnée enregistrée pour ce brouillon.
            </div>
          </div>
          <div class="p-6 border-t border-gray-200 flex-shrink-0">
            <div class="flex gap-4">
              <button @click="resumeDraft" class="buttonComponent w-full rounded-xl font-bold transition">
                Reprendre
              </button>
              <button @click="deleteDraft" class="w-full py-3 bg-red-600 text-white rounded-xl font-bold transition hover:bg-red-700">
                Supprimer
              </button>
            </div>
            <div class="mobile-bottom-padding h-2"></div>
          </div>
        </div>
      </div>
    </div>
  </DialogComponent>
</template>

<script setup>
import { ref } from 'vue'
import { bus } from '@core/events/eventSystem'
import constants from '@core/utils/constants'
import SummaryStep from './wizard/SummaryStep.vue'

const dialog = ref(null)
const draftData = ref(null)
const isOpen = ref(false)

const emit = defineEmits(['delete'])

function showDetails(data) {
  draftData.value = data
  isOpen.value = true
}

function close() {
  isOpen.value = false
}

const onClosed = () => {
  isOpen.value = false
}

function resumeDraft() {
  const currentDraft = draftData.value;
  close()
  setTimeout(() => {
    bus.emit(constants.EVENTS.PACKAGES.WIZARD_OPEN, { draft: currentDraft })
  }, 100)
}

async function deleteDraft() {
  const currentDraft = draftData.value;
  
  const result = await window.confirmDialog({
    title: 'Supprimer le brouillon',
    message: 'Voulez-vous vraiment supprimer ce brouillon ? Cette action est irréversible.',
    successText: 'Supprimer',
    cancelText: 'Annuler'
  });

  if (!result || !result.accepted) return;

  close()
  emit('delete', currentDraft?.id)
}

defineExpose({
  showDetails
})
</script>
